/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteRiskExclusionSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteRiskExclusionSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteRiskExclusionSecurity = {
  option1?: DeleteRiskExclusionSecurityOption1 | undefined;
  option2?: DeleteRiskExclusionSecurityOption2 | undefined;
};

export type DeleteRiskExclusionRequest = {
  /**
   * The exclusion ID.
   */
  id: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteRiskExclusionSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteRiskExclusionSecurityOption1$outboundSchema: z.ZodMiniType<
  DeleteRiskExclusionSecurityOption1$Outbound,
  DeleteRiskExclusionSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function deleteRiskExclusionSecurityOption1ToJSON(
  deleteRiskExclusionSecurityOption1: DeleteRiskExclusionSecurityOption1,
): string {
  return JSON.stringify(
    DeleteRiskExclusionSecurityOption1$outboundSchema.parse(
      deleteRiskExclusionSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteRiskExclusionSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteRiskExclusionSecurityOption2$outboundSchema: z.ZodMiniType<
  DeleteRiskExclusionSecurityOption2$Outbound,
  DeleteRiskExclusionSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteRiskExclusionSecurityOption2ToJSON(
  deleteRiskExclusionSecurityOption2: DeleteRiskExclusionSecurityOption2,
): string {
  return JSON.stringify(
    DeleteRiskExclusionSecurityOption2$outboundSchema.parse(
      deleteRiskExclusionSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteRiskExclusionSecurity$Outbound = {
  Option1?: DeleteRiskExclusionSecurityOption1$Outbound | undefined;
  Option2?: DeleteRiskExclusionSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteRiskExclusionSecurity$outboundSchema: z.ZodMiniType<
  DeleteRiskExclusionSecurity$Outbound,
  DeleteRiskExclusionSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteRiskExclusionSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteRiskExclusionSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteRiskExclusionSecurityToJSON(
  deleteRiskExclusionSecurity: DeleteRiskExclusionSecurity,
): string {
  return JSON.stringify(
    DeleteRiskExclusionSecurity$outboundSchema.parse(
      deleteRiskExclusionSecurity,
    ),
  );
}

/** @internal */
export type DeleteRiskExclusionRequest$Outbound = {
  id: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteRiskExclusionRequest$outboundSchema: z.ZodMiniType<
  DeleteRiskExclusionRequest$Outbound,
  DeleteRiskExclusionRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteRiskExclusionRequestToJSON(
  deleteRiskExclusionRequest: DeleteRiskExclusionRequest,
): string {
  return JSON.stringify(
    DeleteRiskExclusionRequest$outboundSchema.parse(deleteRiskExclusionRequest),
  );
}
